import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

import defaultColor from './defaultColor';

export default function ReorderDotsVerticalIcon(props) {
  const color = props.color === 'secondary' ? '#b1b1b1' : props.color;
  return <SvgIcon {...props} viewBox="0 0 14 14" fill="none">
    <path id="Vector_2" stroke={color || defaultColor} fill="none" strokeLinecap="round" strokeLinejoin="round"
          d="M4 3.5c0.96 0 1.5 -0.54 1.5 -1.5S4.96 0.5 4 0.5 2.5 1.04 2.5 2 3.04 3.5 4 3.5Z" strokeWidth="1"></path>
    <path id="Vector_2_2" stroke={color || defaultColor} fill="none" strokeLinecap="round" strokeLinejoin="round"
          d="M4 8.5c0.96 0 1.5 -0.54 1.5 -1.5S4.96 5.5 4 5.5 2.5 6.04 2.5 7 3.04 8.5 4 8.5Z" strokeWidth="1"></path>
    <path id="Vector_2_3" stroke={color || defaultColor} fill="none" strokeLinecap="round" strokeLinejoin="round"
          d="M4 13.5c0.96 0 1.5 -0.54 1.5 -1.5s-0.54 -1.5 -1.5 -1.5 -1.5 0.54 -1.5 1.5 0.54 1.5 1.5 1.5Z"
          strokeWidth="1"></path>
    <path id="Vector_2_4" stroke={color || defaultColor} fill="none" strokeLinecap="round" strokeLinejoin="round"
          d="M10 3.5c0.96 0 1.5 -0.54 1.5 -1.5S10.96 0.5 10 0.5 8.5 1.04 8.5 2s0.54 1.5 1.5 1.5Z"
          strokeWidth="1"></path>
    <path id="Vector_2_5" stroke={color || defaultColor} fill="none" strokeLinecap="round" strokeLinejoin="round"
          d="M10 8.5c0.96 0 1.5 -0.54 1.5 -1.5s-0.54 -1.5 -1.5 -1.5 -1.5 0.54 -1.5 1.5 0.54 1.5 1.5 1.5Z"
          strokeWidth="1"></path>
    <path id="Vector_2_6" stroke={color || defaultColor} fill="none" strokeLinecap="round" strokeLinejoin="round"
          d="M10 13.5c0.96 0 1.5 -0.54 1.5 -1.5s-0.54 -1.5 -1.5 -1.5 -1.5 0.54 -1.5 1.5 0.54 1.5 1.5 1.5Z"
          strokeWidth="1"></path>
  </SvgIcon>
}
